// extracted by mini-css-extract-plugin
module.exports = {"workedHours":"Tzcs9","comments":"ZddJR","comment":"OXJIY","actions":"hAk0m","label":"-kJRO","buttons":"I3zlW","button":"XsGE6","replaceButton":"qIfd7"};